import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import Compressor from "compressorjs"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, formatDateToISO } from 'pages/Common';
import uploadImage from "../../assets/images/uploadImage.png"
import Dropzone from "react-dropzone"
import { GetObjByPaymentModeType, GetObjByPaymentType } from '_mock/Static_data';

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}
const CreatePurchaseModel = ({ modal, toggle, PurchaseListApi, isEdit, editData, vendors, getPurchaseAmountTransactions }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [isPaid, setIsPaid] = useState(editData?.IsPaid || false)
    const [previewUrl, setPreviewUrl] = useState('')
    const [date, setdate] = useState(dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [vendorId, setVendorId] = useState(0)
    const [bankPaymentMode, setBankPaymentMode] = useState(0)
    const [paymentModeRequired, setPaymentModeRequired] = useState(false)
    const didInit = useRef(false);

    const handlePaidAmount = (text, value) => {
        if ((isEdit && editData?.IsPaid) && (JSON.parse(localStorage.getItem("authUser")).RoleName !== "Admin")) {
            return;
        } else {
            setIsPaid(text == "isEdit" ? value : !value)
        }
    }

    useEffect(() => {
        if (isEdit && editData) {
            setdate(dateFormat(editData?.Date.split("T")[0], "dd-MM-yyyy"));
            setPreviewUrl(editData?.Image);
            setVendorId(editData?.VendorId);
            setBankPaymentMode(editData?.PaymentMode || 0);
            setIsPaid(editData?.IsPaid || false);
            handlePaidAmount("isEdit", editData?.IsPaid)
        } else if (!isEdit) {
            setdate(dateFormat(new Date(), "dd-MM-yyyy"));
            setPreviewUrl('');
            setVendorId(0);
            setBankPaymentMode(0);
            setIsPaid(false);
        }
    }, [modal]);

    // parcel Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            BillNo: editData ? editData.BillNo : '',
            Amount: editData ? editData.TotalAmount : '',
            profilePic: "",
        },
        validationSchema: Yup.object({
            BillNo: Yup.string().required("The bill no is required"),
            Amount: Yup.string().required("The Amount is required"),
            // profilePic: Yup.string().required("The profilePic is required"),
        }),
        onSubmit: values => {
            if (isPaid && bankPaymentMode == 0) {
                setPaymentModeRequired(true)
                return true
            } else {
                setPaymentModeRequired(false)
            }
            if (values) {
                const profilePic =
                    (values.profilePic == "" || values.profilePic == undefined)
                        ? previewUrl
                        : values.profilePic.split(",")[1]
                if (vendorId == 0) {
                    toast.error("Vendor is required", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                    return false
                } else if (profilePic == "" || profilePic == undefined) {
                    toast.error("Image is required", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                    return false
                }
                setformSumitLoading(true)
                isEdit ?
                    putApi("purchase/update", {
                        Id: editData?.Id,
                        BillNo: values.BillNo,
                        vendorId: parseInt(vendorId),
                        Date: formatDateToISO(date),
                        TotalAmount: parseFloat(values.Amount),
                        Image: profilePic,
                        IsPaid: isPaid,
                        PaymentMode: !isPaid ? 0 : parseInt(bankPaymentMode) || 0
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            setformSumitLoading(false)
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            setformSumitLoading(false)
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (PurchaseListApi != '') {
                                PurchaseListApi()
                                getPurchaseAmountTransactions()
                            }
                            setdate(new Date())
                            setPreviewUrl('')
                            setVendorId(0)
                            validation.handleReset()
                        }
                    })
                    :
                    postApi("purchase/create", {
                        BillNo: values.BillNo,
                        vendorId: parseInt(vendorId),
                        Date: formatDateToISO(date),
                        TotalAmount: parseFloat(values.Amount),
                        Image: profilePic,
                        IsPaid: isPaid,
                        PaymentMode: parseInt(bankPaymentMode) || 0
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            setformSumitLoading(false)
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            setformSumitLoading(false)
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (PurchaseListApi != '') {
                                PurchaseListApi()
                                getPurchaseAmountTransactions()
                            }
                            setdate(new Date())
                            setPreviewUrl('')
                            setVendorId(0)
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    const handeleCancel = () => {
        toggle()
        validation.handleReset()
        setPreviewUrl('')
        setdate(new Date())
        setVendorId(0)
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    const toBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl(URL.createObjectURL(compressedResult))
                validation.setFieldValue("profilePic", await toBase64(compressedResult))
            },
        })
    }

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="defualt"
        // style={{ width: !isMobile ? "500px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Purchase" : "Create Purchase"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <div>
                                        <Label htmlFor="FollowupValidation1Custom01" className="required">
                                            Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    // enableTime: true,
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                                value={date}
                                                onChange={(e) => { setdate(e) }}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Bill No.
                                    </Label>
                                    <Input
                                        name="BillNo"
                                        placeholder="Bill No"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.BillNo}
                                        invalid={
                                            validation.touched.BillNo && validation.errors.BillNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.BillNo && validation.errors.BillNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.BillNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md="3" className="">
                                <Label
                                    htmlFor="validationCustom03"
                                    className="required"
                                >
                                    Vendors
                                </Label>
                                <Input
                                    type="select"
                                    id="validationCustom01"
                                    className="form-control-sm"
                                    bsSize='sm'
                                    name="vendor"
                                    // onChange={validation.handleChange}
                                    onChange={e => {
                                        setVendorId(e.target.value)
                                    }}
                                    value={vendorId}
                                >
                                    <option value={0}>Select</option>
                                    {vendors.map((item, index) => {
                                        return (
                                            <option key={index} value={item.Key}>
                                                {item.Value}
                                            </option>
                                        )
                                    })}
                                </Input>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className='required'>
                                        Total Amt.
                                    </Label>
                                    <Input
                                        name="Amount"
                                        disabled={editData?.IsPaid}
                                        placeholder="0"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        onKeyPress={handleKeyPress}
                                        value={validation.values.Amount}
                                        invalid={
                                            validation.touched.Amount && validation.errors.Amount
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Amount && validation.errors.Amount ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Amount}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={2} className='pe-0' style={{ marginTop: "30px" }}>
                                <div className="form-check">
                                    <FormGroup check onClick={() => handlePaidAmount("click", isPaid)}>
                                        <Input
                                            type="checkbox"
                                            disabled={editData?.IsPaid && (JSON.parse(localStorage.getItem("authUser")).RoleName !== "Admin")}
                                            checked={isPaid}
                                            className="form-check-input"
                                            id="auth-remember-check"
                                        />
                                        <label
                                            className="form-check-label"
                                        // onClick={() => handlePaidAmount("click", !isPaid)}
                                        >
                                            Paid
                                        </label>
                                    </FormGroup>
                                </div>
                            </Col>
                            <Col md={3} className='p-0'>
                                <Label
                                    htmlFor="validationCustom03"
                                    className={isPaid ? "required" : ''}
                                >
                                    Payment Mode
                                </Label>
                                <Input
                                    type="select"
                                    disabled={(editData?.IsPaid && !(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin")) || (!isPaid) || ((editData?.IsPaid && !(JSON.parse(localStorage.getItem("authUser")).RoleName === "Admin")) && isPaid)}
                                    id="validationCustom01"
                                    className="form-control-sm"
                                    bsSize='sm'
                                    name="paymentMode"
                                    onChange={e => {
                                        setBankPaymentMode(e.target.value),
                                            setPaymentModeRequired(false)
                                    }}
                                    value={bankPaymentMode}
                                    invalid={paymentModeRequired}
                                >
                                    <option value={0}>
                                        Select
                                    </option>
                                    {GetObjByPaymentModeType(1, 2, 3).map((item, index) => {
                                        return (
                                            <option key={index} value={item.Value}>
                                                {item.Key}
                                            </option>
                                        )
                                    })}
                                </Input>
                                {paymentModeRequired ? (
                                    <FormFeedback type="invalid">
                                        {"PaymentMode Required"}
                                    </FormFeedback>
                                ) : null}
                            </Col>
                        </Row>

                        <Row>
                            <FormGroup>
                                <Dropzone
                                    onDrop={handleDrop}
                                    onClick={handleDrop}
                                    accept="image/*"
                                    multiple={false}
                                    id="profilePic"
                                    name="profilePic"
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <>
                                            <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                {previewUrl ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="175px"
                                                                height="200px"
                                                                src={previewUrl}
                                                                {...getRootProps()}
                                                            />
                                                            {/* <div className="delete-button">
                                          <button
                                            className="btn btn-sm btn-danger mb-1 me-1"
                                            onClick={() => handleclick()}
                                            type="button"
                                          >
                                            <i className=" fs-6 fas fa-trash-alt"></i>
                                          </button>
                                        </div> */}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "175px",
                                                                height: "200px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.profilePic && validation.errors.profilePic ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.profilePic}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </>
                                    )}
                                </Dropzone>
                            </FormGroup>
                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                type="button"
                                onClick={() => handeleCancel()}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default CreatePurchaseModel